import { Center, Loader } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getStockOnHand } from "api/report.service";
import { MAX_PAGE_SIZE } from "common/constants";
import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptSoHs } from "types/model.types";

const StockLevelPreview: React.FC = () => {
  const [data, setData] = useState<RptSoHs>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [params] = useSearchParams();
  const startCode = params.get("f");
  const endCode = params.get("t");
  const searchTerm = params.get("s") ?? "";

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const from: number | null = startCode ? Number(startCode) : null;
        const to: number | null = endCode ? Number(endCode) : null;

        const result = await safeApiCall(
          getStockOnHand(1, MAX_PAGE_SIZE, from, to, false),
        );
        if (mounted && result) setData(result.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  const filteredItems = useMemo(() => {
    const normalizedSearch = (searchTerm ?? "").trim().toLowerCase();

    return data.filter((b) => {
      const name = b.description?.toLowerCase() ?? "";
      const code = b.id?.toString().toLowerCase() ?? "";

      let matchesSearch = true;
      if (normalizedSearch.length >= 3) {
        matchesSearch =
          name.includes(normalizedSearch) || code.includes(normalizedSearch);
      }

      return matchesSearch;
    });
  }, [searchTerm, startCode, endCode, data]);

  const rows = filteredItems.map((p) => {
    let stockLabel = "";

    if (p.onHandCtn <= 0) {
      stockLabel = "No Stock";
    } else if (p.onHandCtn <= 10) {
      stockLabel = "Low Stock";
    } else {
      stockLabel = "Stock OK";
    }

    return (
      <tr key={p.id}>
        <td>{p.id}</td>
        <td className="description">{p.description}</td>
        <td className="money">{p.unitsCtn}</td>
        <td className="money">{p.onHand.toFixed(0)}</td>
        <td className="money">{p.onHandCtn.toFixed(0)}</td>
        <td>{stockLabel}</td>
      </tr>
    );
  });
  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }
  return (
    <>
      <div className="sub-title">Stock on Hand</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Product</th>
            <th className="description">Desscription</th>
            <th className="money">Units / Ctn</th>
            <th className="money">SoH (Units)</th>
            <th className="money">SoH (CTN)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

export default StockLevelPreview;
